import { ThemeApp } from 'themes/types/themeApp/theme.types';
import { themeUi } from '../../themeUi/themeUi';

export const marketplace: ThemeApp['appComponents']['marketplace'] = {
  accessManagement: {
    apiKeys: {
      integrationToolsLinks: {
        color: themeUi.semantic.color.text.neutral800
      },
      divider: {
        backgroundColor: themeUi.semantic.color.background.neutral400
      }
    }
  },

  accountMapping: {
    imageContainer: {
      backgroundColor: themeUi.semantic.color.background.neutral100
    },
    accountMapping: {
      formContainer: {
        backgroundColor: themeUi.semantic.color.text.neutral100,
        boxShadow: 'none',
        border: `1px solid ${themeUi.semantic.color.border.secondary300}`,
        color: themeUi.semantic.color.text.neutral700
      },
      heading: {
        color: themeUi.semantic.color.text.neutral800
      },
      subheading: {
        disabledColor: themeUi.semantic.color.text.neutral500,
        normalColor: themeUi.semantic.color.text.neutral700
      },
      divider: {
        backgroundColor: themeUi.semantic.color.background.neutral400
      },
      noEligibleAccountsSubheading: {
        color: themeUi.semantic.color.text.neutral800
      }
    },

    accountsRadio: {
      accountsRadioGroup: {
        accountName: {
          color: themeUi.semantic.color.text.neutral800,
          disabledColor: themeUi.semantic.color.text.neutral500
        }
      }
    },

    mappingFooter: {
      setupLaterModalSubheading: {
        color: themeUi.semantic.color.text.neutral800
      }
    }
  },

  freeTrial: {
    imageContainer: {
      backgroundColor: themeUi.semantic.color.background.neutral100
    },
    formContainer: {
      backgroundColor: themeUi.semantic.color.text.neutral100,
      boxShadow: 'none',
      border: `1px solid ${themeUi.semantic.color.border.secondary300}`,
      color: themeUi.semantic.color.text.neutral700
    },
    heading: {
      color: themeUi.semantic.color.text.neutral800
    },
    subheading: {
      color: themeUi.semantic.color.text.neutral800
    },
    details: {
      color: themeUi.semantic.color.text.neutral700
    }
  }
};
